import React, { useState } from 'react';

function EmailModal({ isOpen, onClose, selectedCertificates, onSend }) {
  const [recipientEmail, setRecipientEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(recipientEmail)) {
      alert('Please enter a valid email address');
      return;
    }

    setSending(true);
    setSuccess(false);
    try {
      await onSend(recipientEmail, message);
      // Show success message
      setSuccess(true);
      // Close after 2 seconds
      setTimeout(() => {
        setRecipientEmail('');
        setMessage('');
        setSuccess(false);
        onClose();
      }, 2000);
    } catch (error) {
      console.error('Email send error:', error);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Email Certificates</h2>
          <button className="btn-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label className="form-label">Recipient Email *</label>
              <input
                type="email"
                className="form-input"
                value={recipientEmail}
                onChange={(e) => setRecipientEmail(e.target.value)}
                placeholder="employer@company.com"
                required
                disabled={sending}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Message (optional)</label>
              <textarea
                className="form-input"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows="4"
                placeholder="Add a personal message to include with your certificates..."
                disabled={sending}
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                Selected Certificates ({selectedCertificates.length})
              </label>
              <div className="email-cert-list">
                {selectedCertificates.map((cert) => (
                  <div key={cert.id} className="email-cert-item">
                    <span className="email-cert-name">
                      {cert.certificate_name || cert.name}
                    </span>
                    {cert.file_url ? (
                      <span className="email-cert-status">✓ File attached</span>
                    ) : (
                      <span className="email-cert-status-warning">⚠ No file</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="modal-footer">
            {success && (
              <div className="email-success-message">
                ✅ Certificates sent successfully!
              </div>
            )}
            <div className="modal-footer-buttons">
              <button 
                type="button" 
                className="btn btn-outline" 
                onClick={onClose}
                disabled={sending}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={sending || selectedCertificates.length === 0}
              >
                {sending ? 'Sending...' : `Send ${selectedCertificates.length} Certificate${selectedCertificates.length > 1 ? 's' : ''}`}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EmailModal;
